module.exports = __webpack_public_path__ + "static/img/A (31).642b0618.png";